import type { SVGProps } from 'react'
const LineWc = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M16.5 17.5v-11H21V9h1.5V6.25c0-.69-.56-1.25-1.25-1.25h-5C15.56 5 15 5.56 15 6.25v11.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25V14H21v3.5zM2.991 5.136l-1.482.228L3.607 19h1.237a1.25 1.25 0 0 0 1.224-.992l1.485-7.058 1.874 7.118c.144.55.64.932 1.209.932h1.283l1.576-13.664-1.49-.172-1.348 11.685-2.12-8.054a1.066 1.066 0 0 0-2.074.051l-1.676 7.962z"
		/>
	</svg>
)
export { LineWc }
